// Respond.io website chat. The widget finds itself by this script id, so keep it as Respond.io's snippet has it.
const WIDGET_SCRIPT_ID = "respondio__widget";
const WIDGET_SRC = "https://cdn.respond.io/webchat/widget/widget.js";
// Same rule the API applies; the id goes straight into the script URL.
const WIDGET_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

const loadWidgetScript = (widgetId) => {
  if (document.getElementById(WIDGET_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement("script");
  script.id = WIDGET_SCRIPT_ID;
  script.src = `${WIDGET_SRC}?cId=${encodeURIComponent(widgetId)}`;
  script.async = true;
  document.body.appendChild(script);
};

// Loads the widget when the tenant's respond-io integration is enabled and has a webchat widget ID.
export const initiateRespondIoWebchat = (respondIoIntegration) => {
  try {
    const widgetId = String(
      respondIoIntegration?.config?.webchatWidgetId || "",
    ).trim();
    if (respondIoIntegration?.enabled && WIDGET_ID_PATTERN.test(widgetId)) {
      loadWidgetScript(widgetId);
    }
  } catch (err) {
    console.error("Failed to load Respond.io webchat:", err);
  }
};
